import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Grid, Typography } from '@mui/material';
import PropTypes from 'prop-types';
const PageTitle = ({ title, subtitle, actionComponent }) => (_jsxs(Grid, { container: true, justifyContent: "space-between", spacing: 3, sx: { mb: 3 }, children: [_jsxs(Grid, { item: true, children: [_jsx(Typography, { color: "textPrimary", variant: "h5", children: title }), subtitle && (_jsx(Typography, { color: "textSecondary", variant: "subtitle2", children: subtitle }))] }), !!actionComponent && actionComponent()] }));
PageTitle.propTypes = {
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.string,
    actionComponent: PropTypes.func,
};
PageTitle.defaultProps = {
    subtitle: null,
    actionComponent: null,
};
export default PageTitle;
//# sourceMappingURL=PageTitle.js.map